import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";

// 一次性导入 Vant 组件并注册
import {
  Button,
  Popup,
  Picker,
  Form,
  Field,
  Cascader,
  Checkbox,
  Icon,
  Toast,
  Dialog,
  CellGroup,
  Uploader,
} from "vant";
Vue.use(Button);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Form);
Vue.use(Field);
Vue.use(Cascader);
Vue.use(Checkbox);
Vue.use(Icon);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(CellGroup);
Vue.use(Uploader);

Vue.config.productionTip = false;

// 路由守卫，修改页面 title
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
